import type { AuthUser, LoginResponse } from "../types/api.js";
import { getStoredToken } from "../lib/storage-token.js";
import { apiRequest } from "./api-client.js";

export async function loginRequest(email: string, password: string): Promise<LoginResponse> {
  return apiRequest<LoginResponse>("/api/v1/auth/login", {
    method: "POST",
    body: { email, password },
  });
}

export async function meRequest(token: string): Promise<{ user: AuthUser }> {
  return apiRequest<{ user: AuthUser }>("/api/v1/auth/me", {
    method: "GET",
    token,
  });
}

export async function logoutRequest(refreshToken: string): Promise<void> {
  await apiRequest<void>("/api/v1/auth/logout", {
    method: "POST",
    body: { refreshToken },
  });
}

export async function changePasswordRequest(currentPassword: string, newPassword: string): Promise<void> {
  const t = getStoredToken();
  if (!t) throw new Error("No hay sesión.");
  await apiRequest<void>("/api/v1/auth/me/change-password", {
    method: "POST",
    body: { currentPassword, newPassword },
    token: t,
  });
}
